// important: this needs to be in sync with
//            configs/proto/dropbox/proto/riviera/status.proto::RivieraStatus
export var RivieraStatus;
(function (RivieraStatus) {
    RivieraStatus[RivieraStatus["Unknown"] = 0] = "Unknown";
    RivieraStatus[RivieraStatus["OK"] = 1] = "OK";
    RivieraStatus[RivieraStatus["ConversionFailure"] = 2] = "ConversionFailure";
    RivieraStatus[RivieraStatus["TemporaryFailure"] = 3] = "TemporaryFailure";
    RivieraStatus[RivieraStatus["InternalFailure"] = 4] = "InternalFailure";
    RivieraStatus[RivieraStatus["UnsupportedFormat"] = 5] = "UnsupportedFormat";
    RivieraStatus[RivieraStatus["Timeout"] = 6] = "Timeout";
    RivieraStatus[RivieraStatus["TooBig"] = 7] = "TooBig";
    RivieraStatus[RivieraStatus["InvalidMetadata"] = 8] = "InvalidMetadata";
    RivieraStatus[RivieraStatus["SourceCorrupt"] = 9] = "SourceCorrupt";
    RivieraStatus[RivieraStatus["TimeBudgetExceeded"] = 10] = "TimeBudgetExceeded";
    RivieraStatus[RivieraStatus["NotFound"] = 11] = "NotFound";
    RivieraStatus[RivieraStatus["PasswordProtected"] = 12] = "PasswordProtected";
    RivieraStatus[RivieraStatus["InvalidRequest"] = 13] = "InvalidRequest";
    RivieraStatus[RivieraStatus["VirusDetected"] = 14] = "VirusDetected";
    RivieraStatus[RivieraStatus["BlockMissing"] = 15] = "BlockMissing";
    RivieraStatus[RivieraStatus["FeatureDisabled"] = 16] = "FeatureDisabled";
    RivieraStatus[RivieraStatus["PlatformFailure"] = 17] = "PlatformFailure";
    RivieraStatus[RivieraStatus["ContentFlagged"] = 18] = "ContentFlagged";
    RivieraStatus[RivieraStatus["NoContent"] = 19] = "NoContent";
})(RivieraStatus || (RivieraStatus = {}));
export class RivieraError extends Error {
    constructor(message, statusCode = RivieraStatus.Unknown) {
        super(message);
        this.statusCode = statusCode;
        // TODO: Capture stack trace (only avail in V8 so type def doesn't work right now)
    }
}
export class TranscriptRivieraError extends RivieraError {
    constructor(transcriptError = 'error_unknown', statusCode = RivieraStatus.Unknown) {
        super(transcriptError);
        this.statusCode = statusCode;
        this.transcriptError = transcriptError;
    }
}
//# sourceMappingURL=types.preenvesnextjs.map
